import moment from 'moment';
import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import { Button, Col, Container, Row, Table, Tooltip } from "react-bootstrap";
import { ThreeDotSpinner } from '../../common/loader/loader';
import { kycStatusMap, transactionStatus } from '../../common/constant';
import transactionService from '../../service/transactionService';

export const TransactionManagement = () => {

  const [filter, setFilter] = useState({ transactionType: null, search : null})
  const [Loader, setLoader] = useState(false)
  const [transactions, setTransactions] = useState([])
  const [pagination, setPagination] = useState({ pageNumber: 1, pageSize: 10, pageRange: 0, totalCount: 0 })
  const [transactionType ,setTransactionType] = useState("RECEIVE")
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  useEffect(() => {
    fetchTransactions()
  }, [pagination.pageNumber, transactionType])

  const fetchTransactions = async () => {
    setLoader(true);
    const params = { from : startDate,to : endDate,transactionType : transactionType,search : filter.search, page: pagination.pageNumber - 1, size: pagination.pageSize }
    const response = await transactionService.getTransaction(params);
    if (response.status == 200) {
      setLoader(false);
      setTransactions(response.data.data.transaction.transactions)
      setPagination({
        ...pagination,
        totalCount: response.data.data.transaction.count
      })
    }
  }

  const applySearch = (e) => {
    let query = e.target.value.trim()
    if(query=='') query = null
    setFilter({...filter, search: query})
  } 

  const applyFilter = (e) => {
    let query = e.target.value.trim()
    if(query=='' || query=='all') query = null
    setFilter({...filter, status: query})
  } 

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
        fetchTransactions()
    }, 1000); // 1000ms delay

    return () => clearTimeout(delayDebounce);
  }, [filter.search]);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      View
    </Tooltip>
  );

  const renderToggleTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      enable/disable
    </Tooltip>
  );

  const onTransactionTypeChange = (transactionType) => {
    setTransactionType(transactionType);
    setPagination({
      ...pagination,
      pageNumber: 1
    })
  }

  const handlePageChange = (pageNumber) => {
    setPagination({
      ...pagination,
      pageNumber: pageNumber
    })
  };

  return (
    <>
      {Loader && <ThreeDotSpinner />}
      <div className="dashboard-main-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading">

            <Row className="row justify-content-center align-items-center mb-2">
              <Col md={12}>
                <div className="d-flex justify-content-between mb-2">
                  <div className="d-flex ">
                    <h2 className="align-self-center m-0">Transaction Management</h2>
                  </div>
                  <div className='d-flex justify-content-center gap-2'>

                  <div className='filter-section d-flex gap-2 select-cmp'>
                      <div className='position-relative'>
                        <i class="fa fa-search position-absolute w-100" aria-hidden="true"></i>
                        <input type='text' className='form-control' placeholder='Search by Transaction ID...' onInput={ applySearch } />
                      </div>
                    </div>
                    
                    <div className="user-list-top-btn">
                      <Button type="button" variant="unset" className={transactionType == 'RECEIVE' ? 'individual-btn' : 'individual-btn active'} onClick={() => onTransactionTypeChange('RECEIVE')}> Receive</Button>
                      <Button type="button" variant="unset" className={transactionType == 'PAID' ? 'individual-btn' : 'individual-btn active'} onClick={() => onTransactionTypeChange('PAID')}>Paid</Button>
                      <Button type="button" variant="unset" className={transactionType == 'REFUND' ? 'individual-btn' : 'individual-btn active'} onClick={() => onTransactionTypeChange('REFUND')}> Refund</Button>

                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="pb-4 justify-content-center">
              <Col md={12}>
                <div className="audit-request-box">
                  <Table responsive="sm" className="UserListTable">
                    <thead>
                      <tr>
                        <th>Creation Date</th>
                        <th>Transaction ID</th>
                        <th>User ID</th>
                        <th>Order ID</th>
                        <th>Amount</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        transactions.map((transaction, index) => (
                          <tr key={index}>
                            <td>{moment(transaction.createdAt).format('DD-MM-YYYY')}</td>
                            <td>{transaction.transactionId}</td>
                            <td> 
                              <a
                                href={`/users/${transaction?.user}`}
                                target="_blank"
                              >
                                <div className='view-user'>
                                    {transaction.user}
                                </div>
                              </a>
                            </td>
                            <td> 
                              <a
                                href={`/order-detail/${transaction?.order}`}
                                target="_blank"
                              >
                                <div className='view-user'>
                                    {transaction.order}
                                </div>
                              </a>
                            </td>
                            <td>{transaction.amount}</td>
                            <td>{transactionStatus[transaction?.status] || transaction?.status}</td>

                          </tr>
                        ))
                      }

                      {pagination.totalCount == 0 &&

                        <tr className="no-dat-found-box">
                          <td colSpan={10}>
                            <img src={require("../../assets/images/no-data-bg.gif")} alt="no-data-image" />
                            <h3 className="text-center">
                              No data found
                            </h3>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </Table>

                  {pagination.totalCount > pagination.pageSize &&
                    <Pagination
                      activePage={pagination.pageNumber}
                      itemsCountPerPage={pagination.pageSize}
                      totalItemsCount={pagination.totalCount}
                      pageRangeDisplayed={pagination.pageRange}
                      onChange={(e) => handlePageChange(e)}
                      prevPageText={"Prev"}
                      nextPageText={"Next"}
                    />
                  }
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};
